"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let DateRangeSelector = class DateRangeSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_mode = new core_1.ComponentValueCache(this, "mode", () => this.$$load_mode_cache_key());
    }
    $$load_mode_cache_key() {
        return this.name + '.mode';
    }
    getCurrentWeek(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.startOfWeek(t0, { weekStartsOn: 1 }),
            null
        ];
    }
    getCurrentMonth(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.startOfMonth(t0),
            null
        ];
    }
    getCurrentYear(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.startOfYear(t0),
            null
        ];
    }
    getPreviousWeek(...args) {
        const prev_monday = this.$fn.dateFns.previousMonday(this.$fn.dateFns.startOfWeek(new Date(), { weekStartsOn: 1 }));
        return [
            prev_monday,
            this.$fn.dateFns.endOfWeek(prev_monday)
        ];
    }
    getPreviousMonth(...args) {
        const start = this.$fn.dateFns.sub(this.getCurrentMonth()[0], { months: 1 });
        return [
            start,
            this.$fn.dateFns.endOfMonth(start),
        ];
    }
    getPreviousYear(...args) {
        const start = this.$fn.dateFns.sub(this.getCurrentYear()[0], { years: 1 });
        return [
            start,
            this.$fn.dateFns.endOfYear(start),
        ];
    }
    getPreviousSevenDays(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.sub(t0, { days: 7 }),
            null,
        ];
    }
    getPreviousThirtyDays(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.sub(t0, { days: 30 }),
            null,
        ];
    }
    getPreviousSixtyDays(...args) {
        const t0 = new Date();
        return [
            this.$fn.dateFns.sub(t0, { days: 60 }),
            null,
        ];
    }
    onModeChanged(...args) {
        const [key] = args;
        const option = _.find(this.options, { key });
        if (option && option.value) {
            const [start, end] = option.value;
            this.item.start = start ? this.$fn.formatDate(start, 'yyyy-MM-dd') : null;
            this.item.end = end ? this.$fn.formatDate(end, 'yyyy-MM-dd') : null;
            this.$emit('changed', [this.item.start, this.item.end]);
        }
    }
    name;
    onName(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("name");
    }
    from;
    onFrom(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("from");
    }
    to;
    onTo(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("to");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return { start: this.from, end: this.to };
    }
    mode;
    options;
    async $$load_options() {
        return [{
                key: "custom",
                name: this.$fn.pgettext("DateRangeSelector", "Custom"),
            },
            {
                key: "current_week",
                name: this.$fn.pgettext("DateRangeSelector", "Current week"),
                value: this.getCurrentWeek(),
            },
            {
                key: "current_month",
                name: this.$fn.pgettext("DateRangeSelector", "Current month"),
                value: this.getCurrentMonth(),
            },
            {
                key: "current_year",
                name: this.$fn.pgettext("DateRangeSelector", "Current year"),
                value: this.getCurrentYear(),
            },
            {
                key: "previous_week",
                name: this.$fn.pgettext("DateRangeSelector", "Previous week"),
                value: this.getPreviousWeek(),
            },
            {
                key: "previous_month",
                name: this.$fn.pgettext("DateRangeSelector", "Previous month"),
                value: this.getPreviousMonth(),
            },
            {
                key: "previous_year",
                name: this.$fn.pgettext("DateRangeSelector", "Previous year"),
                value: this.getPreviousYear(),
            },
            {
                key: "previous_seven_days",
                name: this.$fn.pgettext("DateRangeSelector", "Previous seven days"),
                value: this.getPreviousSevenDays(),
            },
            {
                key: "previous_thirty_days",
                name: this.$fn.pgettext("DateRangeSelector", "Previous thirty days"),
                value: this.getPreviousThirtyDays(),
            },
            {
                key: "previous_60_days",
                name: this.$fn.pgettext("DateRangeSelector", "Previous sixty days"),
                value: this.getPreviousSixtyDays(),
            },
        ];
    }
    ux;
    b_3943151158818434_style;
    b_4207795475682514_style;
    dataMembers = ['item', 'mode', 'options', 'ux', 'b_3943151158818434_style', 'b_4207795475682514_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                mode: "custom",
                options: null,
                ux: null,
                b_3943151158818434_style: {
                    width: "110px",
                },
                b_4207795475682514_style: {
                    width: "110px",
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_script_2292_getActionArgs_value($event) {
        this.onModeChanged(this.mode);
    }
    async act_6466705138206980_script_2292_getActionArgs($event) {
        return {
            value: () => this.act_6466705138206980_script_2292_getActionArgs_value($event),
        };
    }
    async evh_6466705138206980_input(event, scope) {
        return await this.actions.evh_6466705138206980_input.executeFromDOM(this, event, scope);
    }
    async act_3943151158818434_emit_2294_getActionArgs($event) {
        return {
            event: "changed",
            value: [this.item.start, this.item.end],
        };
    }
    async evh_3943151158818434_input(event, scope) {
        return await this.actions.evh_3943151158818434_input.executeFromDOM(this, event, scope);
    }
    async act_4207795475682514_emit_2296_getActionArgs($event) {
        return {
            event: "changed",
            value: [this.item.start, this.item.end],
        };
    }
    async evh_4207795475682514_input(event, scope) {
        return await this.actions.evh_4207795475682514_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2290 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2289 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2290,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2289],
        });
        const act_6466705138206980_script_2292 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6466705138206980_script_2292_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_input_2291 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_script_2292,
            event: "input",
            displayName: "script",
        });
        const evh_6466705138206980_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_input_2291],
        });
        const act_3943151158818434_emit_2294 = new core_1.actions.EmitAction({
            actionArgs: this.act_3943151158818434_emit_2294_getActionArgs,
            events: [],
        });
        const evh_3943151158818434_input_2293 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_emit_2294,
            event: "input",
            displayName: "emit",
        });
        const evh_3943151158818434_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_input_2293],
        });
        const act_4207795475682514_emit_2296 = new core_1.actions.EmitAction({
            actionArgs: this.act_4207795475682514_emit_2296_getActionArgs,
            events: [],
        });
        const evh_4207795475682514_input_2295 = new core_1.actions.EventHandlerImpl({
            action: act_4207795475682514_emit_2296,
            event: "input",
            displayName: "emit",
        });
        const evh_4207795475682514_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4207795475682514_input_2295],
        });
        return {
            act_7315092382398562_reloadComponentData_2290,
            evh_7315092382398562_reload_2289,
            evh_7315092382398562_reload,
            act_6466705138206980_script_2292,
            evh_6466705138206980_input_2291,
            evh_6466705138206980_input,
            act_3943151158818434_emit_2294,
            evh_3943151158818434_input_2293,
            evh_3943151158818434_input,
            act_4207795475682514_emit_2296,
            evh_4207795475682514_input_2295,
            evh_4207795475682514_input,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], DateRangeSelector.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('name'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DateRangeSelector.prototype, "onName", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], DateRangeSelector.prototype, "from", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('from'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DateRangeSelector.prototype, "onFrom", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], DateRangeSelector.prototype, "to", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('to'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DateRangeSelector.prototype, "onTo", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], DateRangeSelector.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DateRangeSelector.prototype, "onSize", null);
DateRangeSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], DateRangeSelector);
exports.default = DateRangeSelector;
vue_property_decorator_1.Vue.component("DateRangeSelector", DateRangeSelector);
